import { render } from "./Faq.m.vue?vue&type=template&id=e0ec5e2e&scoped=true"
import script from "./Faq.m.vue?vue&type=script&lang=js"
export * from "./Faq.m.vue?vue&type=script&lang=js"

import "./Faq.m.vue?vue&type=style&index=0&id=e0ec5e2e&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ec5e2e"]])

export default __exports__